import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const container = $('.gsap-scroll');
const sections = $('.gsap-scroll__item');

$(document).ready(function () {
  if ($(window).width() <= 768) {
    sections.each(function() {
      $(this).css({
        backgroundImage: `url(${$(this).data('backgroundmobile')})`,
      });
    });
  }
});

gsap.set(container, {height: (sections.length * (110 + 100)) + "vh"});

const navigationArray = $('.gsap-scroll-navigation__item');

const mm = gsap.matchMedia();

mm.add({
  isMobile: "(max-width: 768px)",
  isDesktop: "(min-width: 769px)"
}, (context) => {
  const { isMobile, isDesktop } = context.conditions;

  const radius = Math.round(
    Math.sqrt(
      Math.pow(innerWidth/2, 2) + Math.pow(isMobile ? outerHeight : innerHeight, 2)
    )
  );

  gsap.utils.toArray(".gsap-scroll__item").forEach((panel, i) => {
    if (i === 1) {
      gsap.to(panel, {
        scrollTrigger: {
          trigger: panel,
          start: 0,
          end: outerHeight * 2,
          scrub: isMobile ? 1.1 : true,
          onUpdate: (self) => {
            if (self.progress > 0.5) {
              navigationArray.map(function(item){
                $(this).removeClass('black', 'white');
                $(this).addClass($(panel).data('screencolor'));
                item === i ? $(this).addClass('active') : $(this).removeClass('active');
              });
            } else {
              navigationArray.map(function() {
                $(this).removeClass('black', 'white');
                $(this).addClass($(sections[0]).data('screencolor'));
              });
            }
          },
          onLeaveBack: (self) => {
            navigationArray.map(function(item){
              $(this).removeClass('active');
              item === 0 && $(this).addClass('active');
            });
          }
        },
        clipPath: `circle(${radius}px at 50% 100%)`,
      })
    }

    if (i > 1) {
      gsap.to(panel, {
        scrollTrigger: {
          trigger: panel,
          start: () => isMobile ? (i - 1) * 2 * outerHeight : (i - 1) * 2 * innerHeight,
          end: () => isMobile ? i * 2 * outerHeight : i * 2 * innerHeight,
          scrub: isMobile ? 1.1 : true,
          onUpdate: (self) => {
            if (self.progress > 0.5) {
              navigationArray.map(function(item){
                $(this).removeClass('black', 'white');
                $(this).addClass($(panel).data('screencolor'));
                item === i ? $(this).addClass('active') : $(this).removeClass('active');
              });
            } else {
              navigationArray.map(function() {
                $(this).removeClass('black', 'white');
                $(this).addClass($(sections[i - 1]).data('screencolor'));
              });
            }
          },
        },
        clipPath: `circle(${radius}px at 50% 100%)`,
      })
    }
  });
});
